var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgQr(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 80,
    viewBox: "0 0 80 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_709_1394)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21.2868 16.8761L40.9895 15.7074C30.5855 15.3616 24.4104 15.3616 22.4642 15.5643L19.5568 16.1845C19.1964 16.5303 19.8211 16.745 21.2868 16.8761Z",
    fill: "#808285"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.9175 21.7656L49.3068 21.0739L17.9507 19.9767C13.7819 19.7024 11.4993 19.9767 11.1509 20.74C10.5382 21.7656 12.5445 22.1114 16.9175 21.7656Z",
    fill: "#808285"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.46595 27.9669L54.3742 26.2496L10.3195 25.6891C6.99171 25.6891 5.26172 26.0349 5.26172 26.7266L5.46595 27.9669Z",
    fill: "#808285"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.73317 34.4303L57.8336 32.236L4.63645 31.4012C3.25487 31.5444 2.48598 31.8902 2.34182 32.5699C2.13758 34.0964 4.21597 34.645 8.73317 34.4303Z",
    fill: "#808285"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.64408 40.0116L59.7789 38.5686L6.01711 37.0541C2.54512 37.0541 0.743044 37.6026 0.466726 38.9145C0.406657 39.463 0.815127 39.94 1.64408 40.0116Z",
    fill: "#808285"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.16625 45.8669L19.5474 45.6641L22.1063 42.7662H3.7372C0.962011 42.7662 -0.287425 43.3864 0.0609753 44.6266C0.121044 45.3183 0.469445 45.7953 1.16625 45.8669Z",
    fill: "#808285"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.26152 51.9967L16.9149 51.1738L18.4407 48.5621L4.76895 48.7649C2.13793 48.7649 0.816406 49.3134 0.816406 50.351C0.816406 51.1738 1.16481 51.6628 1.78953 51.7343L5.26152 51.9967Z",
    fill: "#808285"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.0652 57.5061L36.6793 56.3374L34.6009 54.2743L6.02 54.477L3.04057 54.8229C2.69217 55.0971 2.54801 55.5145 2.69217 56.1347C2.89641 57.363 4.42216 57.8519 7.0652 57.5061Z",
    fill: "#808285"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M40.6415 61.1555L11.1596 60.9408C7.55543 60.9408 5.95759 61.3582 6.02967 62.3838C6.37807 63.6956 8.38438 64.0414 12.2048 63.6956L42.4436 63.0039L40.6415 61.1555Z",
    fill: "#808285"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M44.32 67.142L12.6155 66.8677C11.9187 66.8677 11.5703 67.142 11.5703 67.6905C11.5703 68.728 13.7929 69.2051 18.1539 68.9308L47.4316 67.8933L44.32 67.142Z",
    fill: "#808285"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M24.3411 73.2001L41.6891 72.6515L23.5122 71.9598C21.0854 71.614 19.8359 71.8167 19.8359 72.6515L24.3411 73.2001Z",
    fill: "#808285"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M73.6609 8.68333C67.3536 11.3666 55.0755 18.4622 36.8986 30.173C46.2574 25.0093 54.8592 21.0143 62.8364 18.1283L77.0608 13.4416L79.836 13.6443C80.3886 13.9902 79.5597 14.4672 77.6134 15.0277C74.2856 16.0652 68.1105 18.6053 59.0881 22.7435C48.6842 27.4302 42.7133 30.7335 40.9833 32.7966L52.9851 33.0709C51.2431 35.2056 49.1647 36.3743 46.7379 36.5174L44.4553 36.577C47.0983 40.8463 51.3993 43.2553 57.286 43.6011L61.3107 43.8038L61.5149 46.9044L44.6595 48.5502L60.9623 49.5877C61.1785 51.9966 61.1064 53.2369 60.758 53.2369H44.3231L59.4485 55.4431L58.5475 59.295L44.8878 60.3325L57.0217 61.6324L54.1745 65.4843L46.7499 66.4503L52.5045 67.6905L46.1853 72.0314C41.6801 67.5594 38.2802 63.7671 36.1297 60.9407L31.6846 54.811L25.5816 56.1228C30.9277 52.3425 33.763 49.4446 34.2556 47.7273C34.1234 44.424 33.9072 42.2177 33.5588 40.9775L31.3362 43.2433C30.9878 39.94 30.4352 37.8769 29.8825 37.0421L29.0536 39.5941L25.3773 42.7663L28.0084 42.5636C26.4105 51.3765 22.8064 57.0172 17.1239 59.295L13.796 55.8485L16.0907 53.7854L12.6187 54.823L11.9219 53.7854C15.3218 48.2043 17.9528 44.2808 20.0312 42.015L30.0868 32.9278C35.7813 28.2411 40.9833 24.3176 45.909 21.2289C58.7517 13.5012 68.0384 8.61178 73.6609 6.54867C75.8834 5.72582 76.7845 5.857 76.2318 6.75141L73.6609 8.68333Z",
    fill: "#7A003C"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_709_1394"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 80,
    height: 80,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgQr);
export default __webpack_public_path__ + "static/media/QR.9c05c66b68dcfeffe19505b2fd229aba.svg";
export { ForwardRef as ReactComponent };